mainApp.directive('allocatedIpsSelection', function() {
	return {
		templateUrl: '/public/directives/selections/allocatedIpsSelection.html',
		scope: {
			onSelect: '&',
			selectedItems: '=',
		},
		controller: ['$scope', '$state', 'LocationService', '$timeout', function($scope, $state, LocationService, $timeout) {
			$scope.allocatedIpsTableConfig = {
				titleSearch: true,
				dataURL : function(){
					return "/getAllocatedIps?accountId="+$state.params.accountId +"&fetchNatIps=true";
				},
				method: 'GET',
				showTable: false,
				actions: [],
				pageSize:5,
				fields : [
					{"label":"Ip Address","path":"ip","template":"<span>{{item.ip}}</span>"},
					{"label":"Type","path":"type","template":"<span>{{item.type}}</span>"},
					{"label":"Details","path":"location","template":"<span>{{(item.location || item.description) | capitalize}}</span>"}
				],
				type : "Ip",
				processData: function(items) {
					items.forEach(function (item) {
						var location = LocationService.getPopLocationViaLocationId($state.params.accountId, item.locationId);
						if(location && location.name){
							item.location = location.name;
						}
					});
				},
				defer: true,
				selectedItems: [],
				clientSidePaging: true,
				clientSideSearch: true,
				clientSideSort: true,
			};

			function checkLocationForAccount(){
                if (!LocationService.hasLocationForAccount($state.params.accountId)) {
                	$timeout(function() {
                    	checkLocationForAccount();
                    }, 10, false);
                    return;
                }
                $scope.allocatedIpsdatamodified = new Date().getTime();
            }

            checkLocationForAccount();
		}]
	}
});